/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Aero } from './Aero';
import type { ComponentConfigurationSet } from './ComponentConfigurationSet';
import type { DecelerationLimit } from './DecelerationLimit';
import type { Mass } from './Mass';
import type { TransientCalculationPoint } from './TransientCalculationPoint';
import type { WheelInput } from './WheelInput';
import {AncillaryLoad} from "./AncillaryLoad";
/**
 * Dynamic Requirements.
 */
export type DynamicRequirement = {
    item_type?: DynamicRequirement.item_type;
    name?: string;
    description?: string;
    mass?: Mass;
    aero?: Aero;
    wheel?: WheelInput;
    deceleration_limit?: (DecelerationLimit | null);
    state_of_charge?: number;
    component_configurations?: ComponentConfigurationSet;
    ambient_temperature?: number;
    ancillary_load?: (AncillaryLoad | null);
    thermal_analysis?: boolean;
    shift_delta?: number;
    stop_at_temperature_limit?: boolean;
    from_speed?: number;
    to_speed?: number;
    time_step?: number;
    no_of_points?: number;
    base_speed_ratio?: number;
    required_time?: number;
    required_distance?: number;
    altitude?: number;
    headwind?: number;
    gradient?: number;
    max_capability?: boolean;
    front_axle_split?: (number | null);
    base_speed: number;
    end_time: number;
    end_distance: number;
    points: Array<TransientCalculationPoint>;
    voltage_oc: number;
    requirement_type?: DynamicRequirement.requirement_type;
};
export namespace DynamicRequirement {
    export enum item_type {
        REQUIREMENT = 'requirement',
    }
    export enum requirement_type {
        DYNAMIC = 'dynamic',
    }
}

